import { makeAutoObservable } from 'mobx';

import { HttpClient } from 'services/http-client';
// import { AuthRequestDto, LocationDto } from 'services/data-contracts';

export interface isValid {
  isValid: boolean;
}

class LanguageStore {
  // locations?: Array<LocationDto>[];

  constructor() {
    makeAutoObservable(this);
  }


  getLanguage() {
    return [{ code: 'ko', title: '한국어' }, { code: 'en', title: '영어' }, { code: 'ja', title: '일본어' }, { code: 'zh', title: '중국어' }];
  }
}

export default LanguageStore;
